import { render } from "./CheckoutWizard.vue?vue&type=template&id=a634e1ec"
import script from "./CheckoutWizard.vue?vue&type=script&lang=js"
export * from "./CheckoutWizard.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "a634e1ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a634e1ec', script)) {
    api.reload('a634e1ec', script)
  }
  
  module.hot.accept("./CheckoutWizard.vue?vue&type=template&id=a634e1ec", () => {
    api.rerender('a634e1ec', render)
  })

}

script.__file = "src/views/payments/modules/checkout/CheckoutWizard.vue"

export default script